module.exports = __webpack_public_path__ + "html/banner_bc7bb965cdf82425413938fe49a67065.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/banner.html
// module id = IU0M
// module chunks = 118